import React from 'react';
import { ArrowLeft, Clock, User } from 'lucide-react';

export function OrderHeader({ order, formattedArrivalTime, onBackClick }) {
  const customerName = order?.customer_name || '';
  const displayName = customerName.length > 25 
    ? `${customerName.substring(0, 25)}...` 
    : customerName;

  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="px-4 py-3">
        {/* Top Row - Name and Back Button */}
        <div className="flex items-center justify-between mb-2">
          <h1 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-brand-gold text-white text-sm font-bold">
              {order?.sequence}
            </span>
            {displayName}
          </h1>
          
          <button
            onClick={onBackClick}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Volver"
          >
            <ArrowLeft className="w-6 h-6 text-gray-700" />
          </button>
        </div>

        {/* Bottom Row - Order Details */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex flex-col gap-0.5">
            <p className="text-gray-600">
              {order?.store_name || order?.address || 'Sin información'}
            </p>
            <p className="text-xs text-gray-500">
              ID: {order?.id} • Tel: {order?.telefono}
            </p>
          </div>

          {/* Arrival Time */}
          {formattedArrivalTime && (
            <div className="flex items-center gap-1.5 text-gray-700">
              <Clock className="w-4 h-4" />
              <span className="font-medium">{formattedArrivalTime}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}